import React from 'react';
import { FormPayment } from '@app/src/views/StepPayment/formPayment';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

if (isClient) {
  (window as any).transaction = null;
}

export const StepPayment: React.FC = () => (
  <React.Fragment>
    <FormPayment />
  </React.Fragment>
);
